import {useEffect} from 'react'

export function useFooterBorder(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return
    const footer: HTMLDivElement | null = document.querySelector('.footer')
    if (!footer) return

    footer.style.setProperty('border-top', 'var(--borderWidth-thin) solid var(--borderColor-default)')
    footer.style.setProperty('padding', 'var(--base-size-16) 0', 'important')

    return () => {
      footer.style.removeProperty('border-top')
      footer.style.removeProperty('padding')
    }
  }, [enabled])
}
